
import Vue from 'vue';
import App from './App.vue';
// You can change this import to `import router from './starterRouter'` to quickly start development from a blank layout.
import router from './router';
import store from './store'
import UiKit from './plugins/ui-kit';
import AgriConfig from './prototype/config'
import i18n from './i18n/i18n'


// vue-gtag - Vue plugin for Google Analytics, Google Ads, and Google Marketing Platform
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
    config: {
        id: ( process.env.NODE_ENV == 'production' ? 'UA-223288908-1' : 'UA-180666101-2' ),
        disableScriptLoader: true,
        pageTrackerScreenviewEnabled: true,
        appName: "Tung Blossom Forecast"
    },
}, router);


// Import BootstrapVue
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)


// Import VueScrollactive
import VueScrollactive from "vue-scrollactive";
Vue.use(VueScrollactive);


// Import VueMoment
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

Vue.use(VueMoment, {
    moment,
})


// axios
import axiosPlugin from './axios/axiosPlugin'
import axiosSettings from './axios/axiosSettings'
Vue.use(axiosPlugin)



// Import VueScrollTo
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)


Vue.config.productionTip = false;

Vue.use(UiKit);


// 設定 prototype
Vue.prototype.$config = AgriConfig;


new Vue({
    router,
    store,
    i18n,
    moment,
    // config: AgriConfig,
    render: h => h(App),
    created () {
        // 設定 API URL
        this.$config.setAPI_BaseURL();

        // 設定攔截器等 axios 服務
        this.$http.defaults.baseURL = this.$config.API_URL,
        axiosSettings(this);
    },
}).$mount('#app');
